import MDBox from "../../../../components/MDBox";
import pxToRem from "../../../../assets/theme/functions/pxToRem";
import { useCallback, useEffect, useState} from "react";
import {useApi} from "../../../../services/helpers";
import MDTypography from "../../../../components/MDTypography";
import {DoneText, NewPMButton} from "../styles";
import {Icon} from "@mui/material";
import CustomerCell from "../../../../layouts/ecommerce/orders/order-list/components/CustomerCell";
import MDButton from "../../../../components/MDButton";
import MDInput from "../../../../components/MDInput";
import debounce from "lodash.debounce";
import AddBaseModal from "../../../../components/add-base-modal/AddBaseModal";
import {ROLES} from "../../../../services/constants";
import ConfirmDialogModal from "../../../../components/ConfirmDialogModal";
import {observer} from "mobx-react";


export const AddProductModal = observer(({open, item, onClose, loading}) => {
  const api = useApi()
  const [products, setProducts] = useState([])
  const [selectedProducts, setSelectedProducts] = useState(item?.products?.map((item) => item.id) || [])
  const [searchValue, setSearchValue] = useState(null)

  useEffect(() => {
    getProducts({search: ""})
  }, [])

  const getProducts = ({search}) => {
    api.getProducts({
      search: search,
      page: 1,
      ordering: '',
      page_size: 10,
    }).handle({
        onSuccess: (result) => { setProducts(result.data.results) },
        errorMessage: 'Error getting managers',
    })
  }

  const searchProduct = (value) => {
    getProducts({search: value})
  }

  const debouncedInputChange = useCallback(
    debounce(searchProduct, 300)
    , [])

  const addProducts = () => {
    api.updateProductsForGroup(item.id, {products: selectedProducts}).handle({
      successMessage: 'Products updated successfully',
      errorMessage: 'Error updating Products',
      onFinally: () => { onClose() },
    })
  }

  const handleSelectedProducts = (id) => {
    setSelectedProducts(prev =>
      prev.includes(id)
        ? prev.filter(item => item !== id)
        : [...prev, id]
    );
  }

  return (
    <AddBaseModal
      open={open}
      loading={loading}
      handleClose={() => {
        onClose()
      }}
      title={'Update Products'}
      headerContent={
        <MDTypography
          variant='h6'
          sx={DoneText}
          onClick={() => {
            addProducts()
            onClose()
          }}
        >
          Done
        </MDTypography>
      }
      showActions={false}
      modalContainer={{height: pxToRem(820)}}
    >
      <MDBox padding={`${pxToRem(20)} ${pxToRem(24)}`} overflow={'auto'}>
        <MDInput
          sx={{width: '100%'}}
          placeholder={'Search for products'}
          value={searchValue}
          onChange={(e) => {
            debouncedInputChange(e.target.value)
            setSearchValue(e.target.value);
          }}
          InputProps={{
            endAdornment:
              <Icon fontSize='medium' sx={({palette: {icons}}) => ({color: icons.search_icon})}>
                search
              </Icon>
          }}
        />
        <MDBox display='flex' flexDirection='column' gap={pxToRem(28)}>
          {!products.length
            ? <MDBox height={'200px'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                <MDTypography variant='subtitle2'>No products found</MDTypography>
              </MDBox>
            : products.map(product => (
            <MDBox key={product.id} border='none' display='flex' justifyContent='space-between' alignItems='center'>
              <CustomerCell
                name={product.name}
                image={product.main_img}
                color={"dark"}
                styles={{fontSize: '1rem'}}
              />
              <MDButton
                variant={"outlined"}
                color={selectedProducts.includes(product.id) ? "error" : "secondary"}
                onClick={() => {
                  handleSelectedProducts(product?.id)
                }}
                sx={NewPMButton}
              >
                {selectedProducts.includes(product.id)  ? 'Remove' : 'Add'}
              </MDButton>
            </MDBox>
          ))}
        </MDBox>
      </MDBox>
    </AddBaseModal>
  )
})
